import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
import { EntLogisticsCenter } from "../../../models/organic/logisticsCenter";
import { EntLogisticsCenterFilter } from "../../../models/filters/organic/logisticsCenterFilter";

export const logisticsCenterApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getLogisticsCenterListAll: builder.query<ResponseDataGet<EntLogisticsCenter>, EntLogisticsCenterFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.logisticsCenter }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getLogisticsCenterById: builder.query<ResponseDataTest<EntLogisticsCenter>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.logisticsCenter }/${ id }`,
		method: 'GET'
	  })
	}),
	deleteLogisticsCenter: builder.mutation<ResponseDataTest<EntLogisticsCenter>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.logisticsCenter }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetLogisticsCenterListAllQuery,
  useLazyGetLogisticsCenterByIdQuery,
  useDeleteLogisticsCenterMutation
} = logisticsCenterApi;
